import { $service } from '@xt/client/experimental/request/service'
import $global from '@xt/client/store/global'

import type { BookConfig, PlatformConfigSuffix } from '@xt/client/types/book.d'

class BookManager {
  private cache: Map<string, BookConfig>

  constructor() {
    this.cache = new Map()
  }

  async getBook(jsonFileName: `${string}-${PlatformConfigSuffix}.json`) {
    if (this.cache.has(jsonFileName)) {
      return this.cache.get(jsonFileName)!
    }

    const [error, dataSource] = await $service<BookConfig>({
      method: 'GET',
      url: `/mocks/${jsonFileName}`,
      baseURL: $global.production ? 'https://static.xuantong.cn' : 'https://testing-static.xuantong.cn'
    })

    if (error) {
      return null
    }

    this.cache.set(jsonFileName, dataSource)
    return dataSource
  }
}

const bookManager = new BookManager()

export default bookManager
